import { render, staticRenderFns } from "./addSolution.vue?vue&type=template&id=024f6782&scoped=true"
import script from "./addSolution.vue?vue&type=script&lang=js"
export * from "./addSolution.vue?vue&type=script&lang=js"
import style0 from "./addSolution.vue?vue&type=style&index=0&id=024f6782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f6782",
  null
  
)

export default component.exports